import React, { createContext, useState, useEffect } from "react";
import listValuations from "../methods/api/listValuations";

export const ValuationsListContext = createContext();

export const ValuationsListProvider = ({ children }) => {
  const [valuationsList, setValuationsList] = useState([]);
  const [filteredValuationsList, setFilteredValuationsList] = useState([]);

  useEffect(() => {
    listValuations().then((response) => {
      setValuationsList(response);
      setFilteredValuationsList(response);
    });
  }, []);

  return (
    <ValuationsListContext.Provider
      value={{
        valuationsList,
        setValuationsList,
        filteredValuationsList,
        setFilteredValuationsList,
      }}
    >
      {children}
    </ValuationsListContext.Provider>
  );
};
